import SHOW_TOAST from "utils/showToast";
import { ENDPOINTS } from "utils/endpoints";
import { POST_API_CALL } from "utils/services";
import { UPDATE_AUTH, UPDATE_LOGOUT_REDUCER } from "store/actionTypes";
import { APIResponseModal, LoginFormModal } from "utils/modals";

const persistAuthSession = (dispatch: Function, response: APIResponseModal) => {
  const userData = response?.data?.user || response?.data || {};
  const dataToSave = {
    ...userData,
    token: response?.data?.token || response?.data?.accessToken || userData?.token,
  };

  SHOW_TOAST(response?.data?.message, "success");
  sessionStorage.setItem("adminId", dataToSave?._id);
  if (dataToSave?.phone) {
    sessionStorage.setItem("mobileNo", dataToSave.phone);
  }
  dispatch({
    type: UPDATE_AUTH,
    payload: { ...dataToSave, isSessionValid: null },
  });
};

export const loginManually = (data: LoginFormModal, callback: Function) => {
  return (dispatch: Function) => {
    const datToSend = {
      phone: data.phoneNumber,
      password: data.password,
    };
    POST_API_CALL(ENDPOINTS.AUTH.LOGIN, datToSend, (response: APIResponseModal) => {
      if (response.isSuccess) {
        persistAuthSession(dispatch, response);
      }
      callback(response);
    });
  };
};

export const logoutManually = (callback: Function) => {
  return (dispatch: Function) => {
    POST_API_CALL(ENDPOINTS.AUTH.LOGOUT, {}, (response: APIResponseModal) => {
      if (response.isSuccess) {
        SHOW_TOAST(response?.data?.message, "success");
      }
      dispatch({
        type: UPDATE_LOGOUT_REDUCER,
        payload: response,
      });
      callback(response);
    });
  };
};
